/* eslint-disable import/no-unresolved */
/* eslint-disable no-plusplus */
/* eslint-disable no-nested-ternary */
// eslint-disable-next-line import/no-unresolved
import classNames from "classnames";
import { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
// eslint-disable-next-line import/no-unresolved
import Resources from "src/config/Resources";
import { setStepDetails } from "src/redux/Actions/common";

interface Props {
  steps: any;
  currentStep: number;
  //   setStepNo: (value: number) => any;
  showBackArrow: boolean;
  leftSpacingClasses: string;
  stepperValue: string;
  rightSpacingClasses: string;
  circleSizeClasses: string;
}

function CustomStepper({
  steps,
  currentStep,
  //   setStepNo,
  showBackArrow,
  leftSpacingClasses,
  stepperValue,
  rightSpacingClasses,
  circleSizeClasses
}: Props) {
  const [newStep, setNewStep] = useState([
    { completed: true, selected: true, description: "first step" }
  ]);
  const dispatch = useDispatch();
  const stepsRef = useRef();

  // eslint-disable-next-line no-shadow
  const updateStep = (stepNumber: any, steps: any) => {
    const newSteps = [...steps];
    let count = 0;
    while (count < newSteps.length) {
      // current step
      if (count === stepNumber) {
        newSteps[count] = {
          ...newSteps[count],
          highlighted: true,
          selected: true,
          completed: true
        };
        // eslint-disable-next-line no-plusplus
        count++;
      }

      // step completed
      else if (count < stepNumber) {
        newSteps[count] = {
          ...newSteps[count],
          highlighted: false,
          selected: true,
          completed: true
        };
        count++;
      }
      // step pending
      else {
        newSteps[count] = {
          ...newSteps[count],
          highlighted: false,
          selected: false,
          completed: false
        };
        count++;
      }
    }

    return newSteps;
  };

  // const handleClick = (value: number) => {
  //   switch (value) {
  //     case 0:
  //       if (stepperValue === "review") {
  //         dispatch(setStepDetails({ reviewStepNo: 1 }));
  //       }
  //       if (stepperValue === "proposer") {
  //         dispatch(setStepDetails({ proposerStepNo: 1 }));
  //       }
  //       if (stepperValue === "parent") {
  //         dispatch(setStepDetails({ parentStepNo: 1 }));
  //       }
  //       if (stepperValue === "joint") {
  //         dispatch(setStepDetails({ jointStepNo: 1 }));
  //       }
  //       break;
  //     case 1:
  //       if (stepperValue === "review") {
  //         dispatch(setStepDetails({ reviewStepNo: 2 }));
  //       }
  //       if (stepperValue === "proposer") {
  //         dispatch(setStepDetails({ proposerStepNo: 2 }));
  //       }
  //       if (stepperValue === "parent") {
  //         dispatch(setStepDetails({ parentStepNo: 2 }));
  //       }
  //       if (stepperValue === "joint") {
  //         dispatch(setStepDetails({ jointStepNo: 2 }));
  //       }
  //       break;
  //     case 2:
  //       if (stepperValue === "review") {
  //         dispatch(setStepDetails({ reviewStepNo: 3 }));
  //       }
  //       if (stepperValue === "proposer") {
  //         dispatch(setStepDetails({ proposerStepNo: 3 }));
  //       }
  //       if (stepperValue === "parent") {
  //         dispatch(setStepDetails({ parentStepNo: 3 }));
  //       }
  //       if (stepperValue === "joint") {
  //         dispatch(setStepDetails({ jointStepNo: 3 }));
  //       }
  //       break;
  //     case 3:
  //       if (stepperValue === "review") {
  //         dispatch(setStepDetails({ reviewStepNo: 4 }));
  //       }
  //       if (stepperValue === "proposer") {
  //         dispatch(setStepDetails({ proposerStepNo: 4 }));
  //       }
  //       if (stepperValue === "parent") {
  //         dispatch(setStepDetails({ parentStepNo: 4 }));
  //       }
  //       if (stepperValue === "joint") {
  //         dispatch(setStepDetails({ jointStepNo: 4 }));
  //       }
  //       break;
  //     case 4:
  //       if (stepperValue === "review") {
  //         dispatch(setStepDetails({ reviewStepNo: 5 }));
  //       }
  //       if (stepperValue === "proposer") {
  //         dispatch(setStepDetails({ proposerStepNo: 5 }));
  //       }
  //       if (stepperValue === "parent") {
  //         dispatch(setStepDetails({ parentStepNo: 5 }));
  //       }
  //       if (stepperValue === "joint") {
  //         dispatch(setStepDetails({ jointStepNo: 5 }));
  //       }
  //       break;
  //     case 5:
  //       if (stepperValue === "review") {
  //         dispatch(setStepDetails({ reviewStepNo: 6 }));
  //       }
  //       if (stepperValue === "proposer") {
  //         dispatch(setStepDetails({ proposerStepNo: 6 }));
  //       }
  //       if (stepperValue === "parent") {
  //         dispatch(setStepDetails({ parentStepNo: 6 }));
  //       }
  //       if (stepperValue === "joint") {
  //         dispatch(setStepDetails({ jointStepNo: 6 }));
  //       }
  //       break;
  //     case 6:
  //       if (stepperValue === "review") {
  //         dispatch(setStepDetails({ reviewStepNo: 7 }));
  //       }
  //       if (stepperValue === "proposer") {
  //         dispatch(setStepDetails({ proposerStepNo: 7 }));
  //       }
  //       if (stepperValue === "parent") {
  //         dispatch(setStepDetails({ parentStepNo: 7 }));
  //       }
  //       if (stepperValue === "joint") {
  //         dispatch(setStepDetails({ jointStepNo: 7 }));
  //       }
  //       break;
  //     default:
  //       if (stepperValue === "review") {
  //         dispatch(setStepDetails({ reviewStepNo: 1 }));
  //       }
  //       if (stepperValue === "proposer") {
  //         dispatch(setStepDetails({ proposerStepNo: 1 }));
  //       }
  //       if (stepperValue === "parent") {
  //         dispatch(setStepDetails({ parentStepNo: 1 }));
  //       }
  //       if (stepperValue === "joint") {
  //         dispatch(setStepDetails({ jointStepNo: 1 }));
  //       }
  //       break;
  //   }
  // };

  const handleBackArrowClick = () => {
    if (currentStep > 1) {
      //   setStepNo(currentStep - 1);
      if (stepperValue === "review") {
        dispatch(setStepDetails({ reviewStepNo: currentStep - 1 }));
      }
      if (stepperValue === "proposer") {
        dispatch(setStepDetails({ proposerStepNo: currentStep - 1 }));
      }
      if (stepperValue === "parent") {
        dispatch(setStepDetails({ parentStepNo: currentStep - 1 }));
      }
      if (stepperValue === "joint") {
        dispatch(setStepDetails({ jointStepNo: currentStep - 1 }));
      }
    }
  };

  useEffect(() => {
    const stepsState = steps.map((step: any, index: any) => ({
      description: step,
      completed: false,
      highlighted: index === 0,
      selected: index === 0
    }));

    stepsRef.current = stepsState;
    const current = updateStep(currentStep - 1, stepsRef.current);
    setNewStep(current);
  }, [steps, currentStep]);

  const stepsDisplay = newStep.map((step, index) => (
    <div
      // eslint-disable-next-line react/no-array-index-key
      key={index}
      // onClick={() => handleClick(index)}
      role="presentation"
      className={`w-full h-full flex flex-col space-y-1 md:space-y-0 md:flex-row items-center my-auto border-b-5 ${
        step.completed ? "border-outrageousGreen" : "border-desiredDawn"
      }`}
    >
      <div className="relative flex flex-col items-center">
        <div
          className={classNames(
            `flex font-montserrat rounded-full transition duration-500 ease-in-out items-center justify-center py-0 md:py-3 ${
              step.completed
                ? currentStep !== index + 1
                  ? "bg-mediumElectricBlue text-white"
                  : "bg-hotShot text-white"
                : " border-coldMorning border"
            } 
          `,
            circleSizeClasses
          )}
        >
          <p className={`text-sm font-bold ${step.completed ? "text-white" : "text-black"}`}>
            {index + 1}
          </p>
        </div>
      </div>
      <div
        className={`md:ml-2 text-center md:text-start transition duration-500 ease-in-out font-montserrat lg:text-sm text-xxs
            ${
              step.completed
                ? currentStep !== index + 1
                  ? "text-mediumElectricBlue font-bold"
                  : "text-hotShot font-bold"
                : "text-black font-medium"
            }`}
      >
        {step.description}
      </div>
    </div>
  ));

  return (
    <div className="md:h-17.5 h-20 flex mt-2 md:mt-0">
      <div
        className={classNames(
          "border-b-5 border-outrageousGreen flex items-center justify-center",
          leftSpacingClasses
        )}
      >
        {showBackArrow && (
          <div
            onClick={() => handleBackArrowClick()}
            onKeyDown={() => handleBackArrowClick()}
            role="presentation"
            className="flex items-center justify-center w-6 h-6 border rounded-full cursor-pointer lg:h-8 lg:w-8 lg:mr-8 border-coldMorning"
          >
            <img alt="back-arrow" src={Resources.images.Stepper.backArrow} />
          </div>
        )}
      </div>
      <div className={classNames("flex items-center grow justify-between mx-auto")}>
        {stepsDisplay}
      </div>
      <div
        className={classNames(
          `border-b-5 ${
            currentStep === steps.length ? "border-outrageousGreen" : "border-desiredDawn"
          }`,
          rightSpacingClasses
        )}
      />
    </div>
  );
}
export default CustomStepper;
